
const initialState = {
  loading: false,
  data: {},   // { [expertId]: { data: { items: [...] }, loading?: boolean, error?: boolean } }
  error: false,
};

const expertImpactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "EXPERT_IMPACTS_REQ": {
      const expertId = action.meta?.expertId;
      return {
        ...state,
        loading: true,
        error: false,
        data: {
          ...state.data,
          [expertId]: {
            ...(state.data[expertId] || {}),
            loading: true,
            error: false,
          },
        },
      };
    }

    case "EXPERT_IMPACTS_FETCH_SUC": {
      const expertId = action.meta?.expertId;
      // expected GET shape: { status, message, data: { items: [...] } }
      return {
        ...state,
        loading: false,
        error: false,
        data: {
          ...state.data,
          [expertId]: {
            ...(state.data[expertId] || {}),
            loading: false,
            error: false,
            data: action.payload?.data || { items: [] },
          },
        },
      };
    }

    case "EXPERT_IMPACTS_ERR": {
      const expertId = action.meta?.expertId;
      return {
        ...state,
        loading: false,
        error: true,
        data: {
          ...state.data,
          [expertId]: {
            ...(state.data[expertId] || {}),
            loading: false,
            error: true,
          },
        },
      };
    }

    /* ===== CREATE ===== */
    case "EXPERT_IMPACT_CREATE_REQ": {
      const expertId = action.meta?.expertId;
      return {
        ...state,
        data: {
          ...state.data,
          [expertId]: {
            ...(state.data[expertId] || {}),
            creating: true,
            createError: false,
          },
        },
      };
    }

    case "EXPERT_IMPACT_CREATE_SUC": {
      const expertId = action.meta?.expertId;
      const created = action.payload?.data; // single impact object
      const prev = state.data[expertId]?.data?.items || [];
      return {
        ...state,
        data: {
          ...state.data,
          [expertId]: {
            ...(state.data[expertId] || {}),
            creating: false,
            createError: false,
            data: {
              items: [created, ...prev], // prepend newly created impact
            },
          },
        },
      };
    }

    case "EXPERT_IMPACT_CREATE_ERR": {
      const expertId = action.meta?.expertId;
      return {
        ...state,
        data: {
          ...state.data,
          [expertId]: {
            ...(state.data[expertId] || {}),
            creating: false,
            createError: true,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default expertImpactsReducer;
